import {
  createColumnVisibilityStore,
  type ColumnDefinition,
} from "./createColumnVisibilityStore";

/**
 * The product line table's columns, in render order.
 *
 * Labels match the table headers exactly — the menu is a list of what is on screen.
 *
 * Locked: the name that says which row this is, and the actions menu.
 */
export const PRODUCT_LINE_COLUMNS = [
  { id: "tier", label: "Tier" },
  { id: "name", label: "Name", locked: true },
  { id: "cpu", label: "CPU / core" },
  { id: "ram", label: "RAM / GB" },
  { id: "ssd", label: "SSD / GB" },
  { id: "products", label: "Products" },
  { id: "status", label: "Status" },
  { id: "actions", label: "Actions", locked: true },
] as const satisfies readonly ColumnDefinition[];

export type ProductLineColumnId = (typeof PRODUCT_LINE_COLUMNS)[number]["id"];

export const useProductLineColumnsStore = createColumnVisibilityStore<ProductLineColumnId>({
  name: "admin.productLines.columns",
  columns: PRODUCT_LINE_COLUMNS,
});
